import type {Vsop87Element, Vsop87Group} from '@app/types/Vsop87Types';

const VSOP87_L0: Vsop87Element = [
    [0.87401354025],
    [0.11107659762, 3.96205090159, 213.299095438],
    [0.01414150957, 4.58581516874, 7.1135470008],
    [0.00398379389, 0.52112032699, 206.1855484372],
    [0.00350769243, 3.30329907896, 426.598190876],
    [0.00206816305, 0.24658372002, 103.0927742186],
    [0.000792713, 3.84007056878, 220.4126424388],
    [0.00023990355, 4.66976924553, 110.2063212194],
    [0.00016573588, 0.43719228296, 419.4846438752],
    [0.0001582029, 0.93809155235, 632.7837393132],
    [0.00015053543, 2.71669915667, 639.897286314],
    [0.00014906995, 5.76903183869, 316.3918696566],
    [0.00014609559, 1.56518472, 3.9321532631],
    [0.00013160301, 4.44891291899, 14.2270940016],
    [0.00013005299, 5.98119023644, 11.0457002639],
    [0.00010725067, 3.12939523827, 202.2533951741],
    [0.00006126317, 1.76328667907, 277.0349937414],
    [0.00005863206, 0.23656938524, 529.6909650946],
    [0.00005227757, 4.20783365759, 3.1813937377],
    [0.00005019687, 3.17787728405, 433.7117378768],
    [0.0000459255, 0.61977744975, 199.0720014364],
    [0.00004005867, 2.24479718502, 63.7358983034],
    [0.0000387367, 3.22283226966, 138.5174968707],
    [0.00003269484, 0.77492638211, 949.1756089698],
    [0.00002953796, 0.98280366998, 95.9792272178],
    [0.00002461186, 2.03163875071, 735.8765135318],
    [0.00001758145, 3.2658010994, 522.5774180938],
    [0.00001640172, 5.5050445305, 846.0828347512],
    [0.00001580648, 4.37265307169, 309.2783226558],
    [0.00001391327, 4.02333150505, 323.5054166574],
    [0.00001123498, 2.83726798446, 415.5524906121],
    [0.00001087229, 4.1834325756, 2.4476805548],
    [0.00001017275, 3.71700135395, 227.5261894396],
    [0.00000956757, 0.50744342622, 1265.5674786264],
    [0.00000852677, 3.42141279787, 175.1660598002],
    [0.00000848642, 3.1915017083, 209.3669421749],
    [0.00000789205, 5.00745127508, 0.9632078465],
    [0.00000748819, 2.14396789786, 853.196381752],
    [0.00000743599, 5.25277685028, 224.3447957019],
    [0.00000686999, 1.74714152638, 1052.2683831884],
    [0.00000654484, 1.59889329033, 0.0481841098],
    [0.00000633982, 2.29887419204, 412.3710968744],
    [0.00000624883, 0.9704808751, 210.1177017003],
    [0.00000579844, 3.09254750266, 74.7815985673],
    [0.00000546365, 2.12677911914, 350.3321196004],
    [0.00000542648, 1.51824981131, 9.5612275556],
    [0.00000529874, 4.44938991187, 117.3198682202],
    [0.00000478044, 2.96486700885, 137.0330241624],
    [0.00000474277, 5.47526482059, 742.9900605326],
    [0.00000451857, 1.04437293342, 490.3340891794],
    [0.00000448547, 1.28991363969, 127.4717966068],
    [0.00000372318, 2.27822895353, 217.2312487011],
    [0.00000354988, 3.01280169452, 838.9692877504],
    [0.00000347422, 1.53923267387, 340.7708920448],
    [0.00000343481, 0.24603836481, 0.5212648618],
    [0.00000330197, 0.24721738903, 1581.959348283],
    [0.00000322189, 0.96136528867, 203.7378678824],
    [0.00000321562, 2.57185176731, 647.0108333148],
    [0.00000309029, 3.49491017725, 216.4804891757],
    [0.00000286703, 2.37046001635, 351.8165923087],
    [0.00000277774, 0.40024010033, 211.8146227297],
    [0.00000249142, 1.47004230445, 1368.660252845],
    [0.00000226601, 4.90997278296, 12.5301729722],
    [0.00000220225, 4.20421716654, 200.7689224658],
    [0.0000020865, 1.34533476508, 625.6701923124],
    [0.00000207666, 1.28298038875, 39.3568759152],
    [0.00000207645, 0.48344140678, 1162.4747044078],
    [0.0000020452, 6.01073368945, 265.9892934775],
    [0.00000184698, 3.50349102817, 149.5631971346],
    [0.00000183509, 0.97260974474, 4.192785694],
    [0.00000182459, 5.49122412646, 2.9207613068],
    [0.00000173914, 1.86305647242, 0.7507595254],
    [0.00000164541, 0.44004693949, 5.4166259714],
    [0.00000149302, 5.73592320434, 52.6901980395],
    [0.00000147544, 1.53530368067, 5.6290742925],
    [0.00000146074, 6.23107926975, 195.1398481733],
    [0.0000013969, 4.29463428594, 21.3406410024],
    [0.00000131292, 4.06829024226, 10.2949407385],
    [0.0000012498, 6.27738701225, 1898.3512179396],
    [0.00000122371, 1.97585460706, 4.665866446],
];

const VSOP87_L1: Vsop87Element = [
    [213.2990952169],
    [0.01297370862, 1.82834923978, 213.299095438],
    [0.00564345393, 2.88499717272, 7.1135470008],
    [0.00107674962, 2.27769131009, 206.1855484372],
    [0.00093734369, 1.06311793502, 426.598190876],
    [0.00040244455, 2.04108104671, 220.4126424388],
    [0.00019941774, 1.2795439047, 103.0927742186],
    [0.00010511678, 2.7488034213, 14.2270940016],
    [0.00006416106, 0.38238295041, 639.897286314],
    [0.00004848994, 2.43037610229, 419.4846438752],
    [0.00004056892, 2.92133209468, 110.2063212194],
    [0.00003768635, 3.6496533078, 3.9321532631],
    [0.00003384691, 2.41694503459, 3.1813937377],
    [0.00003231693, 1.26149969158, 433.7117378768],
    [0.00003071405, 2.32739504783, 199.0720014364],
    [0.00001953179, 3.56378136497, 11.0457002639],
    [0.00001249468, 2.62810757084, 95.9792272178],
    [0.0000092135, 1.96069472334, 227.5261894396],
    [0.00000701524, 4.43097553887, 529.6909650946],
    [0.00000649591, 6.17410622073, 202.2533951741],
    [0.00000627498, 6.1110981622, 309.2783226558],
    [0.00000478347, 4.98809792152, 522.5774180938],
    [0.00000468362, 4.61704486774, 63.7358983034],
    [0.00000440442, 6.0186116335, 853.196381752],
    [0.000004088, 2.10122200324, 323.5054166574],
    [0.00000407654, 1.29967965754, 209.3669421749],
    [0.00000346963, 2.24152661493, 632.7837393132],
    [0.0000034372, 3.95819456535, 412.3710968744],
    [0.00000338569, 3.63538109408, 316.3918696566],
    [0.00000336129, 3.77170200605, 735.8765135318],
    [0.00000331895, 2.86077271205, 210.1177017003],
    [0.00000289484, 2.73211009526, 117.3198682202],
    [0.0000028091, 5.74399466555, 2.4476805548],
    [0.000002541, 0.54280472223, 647.0108333148],
    [0.00000230497, 1.64428691304, 216.4804891757],
    [0.00000192275, 2.96534476762, 224.3447957019],
    [0.00000171342, 4.09606536666, 846.0828347512],
    [0.0000016711, 2.59746814308, 21.3406410024],
    [0.00000136321, 2.28588945465, 10.2949407385],
    [0.00000129468, 3.4486372972, 742.9900605326],
    [0.00000127864, 4.09556557491, 217.2312487011],
    [0.00000109809, 6.16222822735, 415.5524906121],
    [0.00000097503, 4.72798517062, 838.9692877504],
    [0.00000093929, 3.48395603528, 1052.2683831884],
    [0.000000925, 3.94738565799, 88.865680217],
    [0.00000085414, 1.21992749767, 440.8252848776],
    [0.00000083544, 3.11243528672, 625.6701923124],
];

const VSOP87_L2: Vsop87Element = [
    [0.0011644133, 1.17988132879, 7.1135470008],
    [0.00091841837, 0.0732519584, 213.299095438],
    [0.00036661728],
    [0.00015274496, 4.06493179167, 206.1855484372],
    [0.00010987259, 5.4447918831, 426.598190876],
    [0.0001062983, 0.25764306189, 220.4126424388],
    [0.00004265404, 1.04596041482, 14.2270940016],
    [0.00001215447, 2.91866579609, 103.0927742186],
    [0.00001142595, 4.63711665368, 639.897286314],
    [0.00001061494, 5.68896768215, 433.7117378768],
    [0.00001044759, 4.04202827818, 199.0720014364],
    [0.00001020102, 0.6336845725, 3.1813937377],
    [0.00000648857, 4.33990455509, 419.4846438752],
    [0.0000054932, 5.57301151406, 3.9321532631],
    [0.00000456767, 1.2689684848, 110.2063212194],
    [0.00000424918, 0.20908786519, 227.5261894396],
    [0.00000273782, 4.2885706119, 95.9792272178],
    [0.00000161533, 1.38145587317, 11.0457002639],
    [0.00000129502, 1.56592444783, 309.2783226558],
    [0.00000108829, 3.89769392463, 853.196381752],
    [0.00000100917, 0.89243113369, 21.3406410024],
    [0.0000010071, 4.89713543344, 647.0108333148],
    [0.000000955, 2.91469950689, 316.3918696566],
    [0.00000095154, 5.62447011514, 412.3710968744],
    [0.00000084889, 5.73495539065, 209.3669421749],
    [0.00000082667, 6.05014465562, 216.4804891757],
    [0.00000081962, 1.02414352999, 117.3198682202],
    [0.0000007486, 4.76187112999, 210.1177017003],
    [0.00000067164, 0.45592762644, 522.5774180938],
    [0.00000066442, 0.48307559227, 10.2949407385],
    [0.00000064191, 0.35066202401, 323.5054166574],
    [0.00000053849, 2.71027004601, 529.6909650946],
    [0.00000052073, 4.77422682479, 632.7837393132],
    [0.00000045297, 1.66820818508, 202.2533951741],
    [0.00000044991, 5.69247085773, 440.8252848776],
    [0.00000042349, 5.70774454577, 88.865680217],
    [0.0000003205, 0.06977561095, 63.7358983034],
];

const VSOP87_L3: Vsop87Element = [
    [0.00016038732, 5.73945573267, 7.1135470008],
    [0.00004254737, 4.58877599687, 213.299095438],
    [0.00001906379, 4.7607084357, 220.4126424388],
    [0.00001464959, 5.91328884284, 206.1855484372],
    [0.00001162062, 5.61974313217, 14.2270940016],
    [0.00001044765, 3.57813061587, 426.598190876],
    [0.00000237009, 5.76820709729, 199.0720014364],
    [0.00000236068, 3.85849798708, 433.7117378768],
    [0.00000165645, 5.11642167451, 3.1813937377],
    [0.00000150882, 2.72695802283, 639.897286314],
    [0.00000131328, 4.74306126145, 227.5261894396],
    [0.00000063899, 0.08672623762, 419.4846438752],
    [0.00000061607, 4.74260728276, 103.0927742186],
    [0.00000040405, 5.47280316518, 21.3406410024],
    [0.00000040222, 5.96343977224, 95.9792272178],
    [0.00000038807, 5.83309187434, 110.2063212194],
    [0.00000026949, 3.00877360899, 647.0108333148],
    [0.00000025017, 0.98675576491, 3.9321532631],
    [0.00000018497, 1.9253436571, 853.196381752],
    [0.00000018212, 4.96397771331, 10.2949407385],
    [0.00000018051, 1.021817946, 412.3710968744],
    [0.00000017889, 4.20422746039, 216.4804891757],
];

const VSOP87_L4: Vsop87Element = [
    [0.00001661877, 3.99824447634, 7.1135470008],
    [0.00000257094, 2.98422287887, 220.4126424388],
    [0.00000236328, 3.9024884432, 14.2270940016],
    [0.0000014952, 2.73191135434, 213.299095438],
    [0.00000109412, 1.51564560686, 206.1855484372],
    [0.00000069119, 1.74804093636, 426.598190876],
    [0.00000039678, 2.04527339062, 433.7117378768],
    [0.0000003768, 1.23800346661, 199.0720014364],
    [0.00000031172, 3.01055217526, 227.5261894396],
];

const VSOP87_L5: Vsop87Element = [
    [0.00000123607, 2.25923420203, 7.1135470008],
    [0.00000034176, 2.16278773143, 14.2270940016],
];

const VSOP87_B0: Vsop87Element = [
    [0.04330678039, 3.60284428399, 213.299095438],
    [0.00240348302, 2.85238489373, 426.598190876],
    [0.00084745939],
    [0.00034116062, 0.57297307557, 206.1855484372],
    [0.00030863357, 3.48441504555, 220.4126424388],
    [0.0001473407, 2.11846596715, 639.897286314],
    [0.00009916667, 5.79003188904, 419.4846438752],
    [0.00006993564, 4.7360468972, 7.1135470008],
    [0.00004807588, 5.43305312061, 316.3918696566],
    [0.00004788392, 4.96512926584, 110.2063212194],
    [0.00003432125, 2.732557466, 433.7117378768],
    [0.00001506129, 6.01304519391, 103.0927742186],
    [0.00001060298, 5.6309929646, 529.6909650946],
    [0.00000969071, 5.20434966293, 632.7837393132],
    [0.0000094205, 1.39646688872, 853.196381752],
    [0.00000707645, 3.80302289005, 323.5054166574],
    [0.00000552314, 5.13149119536, 202.2533951741],
    [0.00000399674, 3.35891409671, 227.5261894396],
    [0.0000031938, 3.62571687438, 209.3669421749],
    [0.00000316063, 1.99716693551, 647.0108333148],
    [0.00000314224, 0.46510248959, 217.2312487011],
    [0.00000284495, 4.88648507126, 224.3447957019],
    [0.00000236441, 2.13887684631, 11.0457002639],
    [0.00000215354, 5.9498256102, 846.0828347512],
    [0.00000208523, 2.12003937634, 415.5524906121],
    [0.00000207214, 0.73021353207, 199.0720014364],
    [0.00000178958, 2.95361337281, 63.7358983034],
    [0.00000140585, 0.64417933116, 490.3340891794],
    [0.0000013924, 4.59535592976, 14.2270940016],
    [0.0000013914, 1.99821987827, 735.8765135318],
    [0.00000134884, 5.24501026174, 742.9900605326],
    [0.00000121669, 3.11537142395, 522.5774180938],
    [0.00000115525, 3.1089202092, 216.4804891757],
    [0.00000114218, 0.96262037933, 210.1177017003],
    [0.00000096377, 4.48164269503, 117.3198682202],
    [0.00000080594, 1.31693242934, 277.0349937414],
    [0.00000074302, 2.89377583784, 149.5631971346],
    [0.00000072953, 3.05987977572, 536.8045120954],
    [0.00000069261, 4.92378376874, 309.2783226558],
    [0.00000068041, 2.1800128871, 351.8165923087],
    [0.00000061733, 0.67727575242, 1066.49547719],
    [0.00000056598, 2.6096247711, 440.8252848776],
    [0.00000048864, 5.78725829726, 95.9792272178],
];

const VSOP87_B1: Vsop87Element = [
    [0.00198927992, 4.93901017903, 213.299095438],
    [0.00017966989, 0.5197943111, 426.598190876],
    [0.00013320265, 2.26481519893, 206.1855484372],
    [0.00010919721, 1.79463271368, 220.4126424388],
    [0.00003243428, 1.21094033148, 419.4846438752],
    [0.00002900519, 6.17033461979, 639.897286314],
    [0.00001584712, 0.9341639713, 433.7117378768],
    [0.00001580666, 3.08171717435, 7.1135470008],
    [0.00000700659, 0.20545152078, 316.3918696566],
    [0.00000310902, 4.38351712708, 110.2063212194],
    [0.00000303761, 5.46322830151, 853.196381752],
    [0.00000301237, 1.66219956459, 227.5261894396],
    [0.00000259878, 3.93026240568, 103.0927742186],
    [0.00000252673, 0.9002092521, 632.7837393132],
    [0.00000182664, 0.12142438148, 647.0108333148],
    [0.00000157532, 2.42607457234, 199.0720014364],
    [0.00000108184, 1.39896246207, 529.6909650946],
    [0.00000093226, 2.4431495804, 217.2312487011],
    [0.00000088301, 2.17503185037, 323.5054166574],
    [0.00000086875, 2.91365320786, 14.2270940016],
    [0.00000076217, 2.73666477702, 210.1177017003],
    [0.00000069585, 1.31682001912, 216.4804891757],
    [0.00000067406, 1.49053395808, 209.3669421749],
    [0.00000053865, 1.74961587267, 202.2533951741],
    [0.00000048657, 0.85586786255, 440.8252848776],
    [0.00000038289, 2.90107344056, 117.3198682202],
];

const VSOP87_B2: Vsop87Element = [
    [0.00013884264, 0.08994998691, 213.299095438],
    [0.00003075713, 3.9161093762, 206.1855484372],
    [0.00002081666, 0.09631968077, 220.4126424388],
    [0.00001452574, 5.48867576013, 426.598190876],
    [0.00000546808, 2.94585826799, 419.4846438752],
    [0.00000391398, 5.43939792344, 433.7117378768],
    [0.0000031974, 4.34820275048, 639.897286314],
    [0.00000220164],
    [0.00000203518, 1.37396136744, 7.1135470008],
    [0.00000116719, 6.24505924943, 227.5261894396],
    [0.00000067605, 1.75135990376, 316.3918696566],
    [0.00000064044, 4.10904350356, 199.0720014364],
    [0.00000055518, 4.56815095513, 647.0108333148],
    [0.00000049875, 3.48944345784, 853.196381752],
    [0.00000038984, 2.7993042852, 632.7837393132],
    [0.00000027643, 1.22439852303, 14.2270940016],
    [0.00000024804, 4.48123972552, 210.1177017003],
    [0.00000021498, 5.38853499774, 440.8252848776],
];

const VSOP87_B3: Vsop87Element = [
    [0.00000487242, 5.57827705588, 206.1855484372],
    [0.00000463357, 1.69194209337, 213.299095438],
    [0.00000277451],
    [0.00000270686, 4.65445792593, 220.4126424388],
    [0.00000069846, 3.33236270677, 426.598190876],
    [0.00000066718, 3.66337287998, 433.7117378768],
    [0.00000065617, 4.71263096227, 419.4846438752],
    [0.00000030551, 4.53651131935, 227.5261894396],
];

const VSOP87_B4: Vsop87Element = [
    [0.00000058521, 0.96404269672, 206.1855484372],
    [0.00000027345, 2.90816987834, 220.4126424388],
];

const VSOP87_B5: Vsop87Element = [];

const VSOP87_R0: Vsop87Element = [
    [9.55758135486],
    [0.52921382865, 2.39226219573, 213.299095438],
    [0.01873679867, 5.2354960466, 206.1855484372],
    [0.01464663929, 1.64763042902, 426.598190876],
    [0.00821891141, 5.93520042303, 316.3918696566],
    [0.00547506923, 5.0153261898, 103.0927742186],
    [0.0037168465, 2.27114821115, 220.4126424388],
    [0.00361778765, 3.13904301847, 7.1135470008],
    [0.00140617506, 5.70406606781, 632.7837393132],
    [0.00108974848, 3.29313390175, 110.2063212194],
    [0.00069006962, 5.94099540992, 419.4846438752],
    [0.00061053367, 0.94037691801, 639.897286314],
    [0.00048913294, 1.55733638681, 202.2533951741],
    [0.00034143772, 0.19519102597, 277.0349937414],
    [0.00032401773, 5.47084567016, 949.1756089698],
    [0.00020936596, 0.46349251129, 735.8765135318],
    [0.000208393, 1.52102476129, 433.7117378768],
    [0.00020746751, 5.33255457763, 199.0720014364],
    [0.00015298404, 3.0594381494, 529.6909650946],
    [0.00014296484, 2.60433479142, 323.5054166574],
    [0.00012884624, 1.64890652873, 138.5174968707],
    [0.00011993338, 5.98050967385, 846.0828347512],
    [0.00011380257, 1.7310542704, 522.5774180938],
    [0.00009796004, 5.20477537945, 1265.5674786264],
    [0.00007752664, 5.85190720634, 95.9792272178],
    [0.00006770608, 3.00432308205, 14.2270940016],
    [0.00006465823, 0.17732249942, 1052.2683831884],
    [0.00005850459, 1.45520063003, 415.5524906121],
    [0.0000530742, 0.597422002, 63.7358983034],
    [0.00004695487, 2.14913875148, 227.5261894396],
    [0.00004044055, 1.64006628713, 209.3669421749],
    [0.00003688237, 0.78017261355, 412.3710968744],
    [0.00003460944, 1.8508869805, 175.1660598002],
    [0.00003419618, 4.94550542171, 1581.959348283],
    [0.00003400702, 0.55385265588, 350.3321196004],
    [0.00003376576, 3.69526804193, 224.3447957019],
    [0.00002975955, 5.6846913175, 210.1177017003],
    [0.00002885428, 1.38764476428, 838.9692877504],
    [0.000028811, 0.17962517668, 853.196381752],
    [0.00002507656, 3.53854849756, 742.9900605326],
    [0.00002448261, 6.18411000897, 1368.660252845],
    [0.00002406134, 2.96557066697, 117.3198682202],
    [0.00002173933, 0.01504273441, 340.7708920448],
    [0.00002024755, 5.05404443168, 11.0457002639],
    [0.00001888373, 0.02965674854, 3.9321532631],
    [0.00001861491, 5.93369815396, 625.6701923124],
    [0.00001817173, 5.77721016746, 490.3340891794],
    [0.00001781073, 0.76321113173, 217.2312487011],
    [0.00001740284, 2.34658553206, 309.2783226558],
    [0.00001610962, 1.17294612833, 74.7815985673],
    [0.00001474674, 5.67670456599, 203.7378678824],
    [0.00001472651, 1.40074361969, 137.0330241624],
    [0.00001462651, 1.92592107843, 216.4804891757],
    [0.00001395118, 5.93681366484, 127.4717966068],
    [0.00001314853, 5.11211291628, 211.8146227297],
    [0.00001304238, 0.77242217158, 647.0108333148],
    [0.00001295446, 4.69181789263, 1898.3512179396],
    [0.00001277624, 2.98416387533, 1059.3819301892],
    [0.00001207069, 0.75304212507, 351.8165923087],
    [0.00001149625, 5.74018465658, 1162.4747044078],
];

const VSOP87_R1: Vsop87Element = [
    [0.0618298134, 0.2584351148, 213.299095438],
    [0.00506577242, 0.71114625261, 206.1855484372],
    [0.00341394029, 5.79635741658, 426.598190876],
    [0.00188491195, 0.47215589652, 220.4126424388],
    [0.00143891146, 1.40744822888, 7.1135470008],
    [0.00049621208, 6.0174427982, 103.0927742186],
    [0.00020928426, 5.09244947411, 639.897286314],
    [0.00019952564, 1.1756060613, 419.4846438752],
    [0.00018839544, 1.60818334043, 110.2063212194],
    [0.00013876849, 0.75884928866, 199.0720014364],
    [0.00012892843, 5.9432943302, 433.7117378768],
    [0.00005396842, 1.28853589711, 14.2270940016],
    [0.00004869289, 0.86797227054, 323.5054166574],
    [0.00004247221, 0.39294984732, 227.5261894396],
    [0.00003252331, 1.2585015433, 95.9792272178],
    [0.0000308141, 3.43662543526, 522.5774180938],
    [0.0000290954, 4.60680719251, 202.2533951741],
    [0.00002856066, 2.1673128387, 735.8765135318],
    [0.00001987731, 2.45053765034, 412.3710968744],
    [0.00001941443, 6.02392296904, 209.3669421749],
    [0.00001581782, 1.29189091556, 210.1177017003],
    [0.00001339521, 4.30812522038, 853.196381752],
    [0.00001315459, 1.25295611814, 117.3198682202],
    [0.00001202869, 1.86661895487, 316.3918696566],
    [0.00001090827, 0.07529636493, 216.4804891757],
    [0.00000965957, 0.47988871608, 632.7837393132],
    [0.000009543, 5.15171167674, 647.0108333148],
    [0.00000897508, 0.98347755563, 529.6909650946],
    [0.00000882063, 1.88467410042, 1052.2683831884],
    [0.0000087431, 1.40216274572, 224.3447957019],
    [0.00000784828, 3.06374185689, 838.9692877504],
    [0.00000739765, 1.38209924525, 625.6701923124],
    [0.00000658132, 4.1437471502, 309.2783226558],
    [0.0000064959, 1.72473111863, 742.9900605326],
    [0.0000061293, 3.03309390383, 63.7358983034],
    [0.00000599227, 2.54946247931, 217.2312487011],
    [0.00000502951, 2.12941646895, 3.9321532631],
    [0.00000412937, 4.59321186186, 415.5524906121],
    [0.00000394995, 0.5339710376, 956.2891559706],
    [0.00000362976, 4.7059780752, 302.164775655],
    [0.00000355987, 2.30328555624, 728.762966531],
    [0.00000344652, 5.88820160547, 440.8252848776],
];

const VSOP87_R2: Vsop87Element = [
    [0.00436902572, 4.78671677509, 213.299095438],
    [0.00071922498, 2.5007006993, 206.1855484372],
    [0.00049766872, 4.97167777235, 220.4126424388],
    [0.00043220783, 3.86941044212, 426.598190876],
    [0.00029645766, 5.96309886479, 7.1135470008],
    [0.00004720822, 2.47524028389, 199.0720014364],
    [0.00004141687, 4.10673009419, 433.7117378768],
    [0.00003789321, 3.0977118974, 639.897286314],
    [0.00002963981, 1.37198670946, 103.0927742186],
    [0.00002556403, 2.85066948131, 419.4846438752],
    [0.00002326777],
    [0.00002208473, 6.27590108662, 110.2063212194],
    [0.00002187311, 5.8554501714, 14.2270940016],
    [0.00001956779, 4.92451269861, 227.5261894396],
    [0.00000923829, 5.4638968891, 323.5054166574],
    [0.00000705974, 2.97065900638, 95.9792272178],
    [0.00000545943, 4.12843012325, 412.3710968744],
    [0.00000431231, 5.17807636127, 522.5774180938],
    [0.00000404424, 4.17313476718, 209.3669421749],
    [0.00000390607, 4.48122593284, 216.4804891757],
    [0.00000373763, 5.8341214698, 117.3198682202],
    [0.00000360843, 3.27730304283, 647.0108333148],
    [0.00000356448, 3.19046275776, 210.1177017003],
    [0.00000325474, 2.26775488379, 853.196381752],
    [0.00000206684, 4.02119282093, 735.8765135318],
    [0.00000204458, 0.08803952503, 202.2533951741],
    [0.00000179903, 3.59725930296, 632.7837393132],
    [0.00000177973, 4.09718163123, 440.8252848776],
];

const VSOP87_R3: Vsop87Element = [
    [0.00020315239, 3.02186068237, 213.299095438],
    [0.00008923679, 3.19144467228, 220.4126424388],
    [0.00006908768, 4.35175288182, 206.1855484372],
    [0.00004087056, 4.22398596149, 7.1135470008],
    [0.00003878848, 2.01051759517, 426.598190876],
    [0.00001070754, 4.20372656114, 199.0720014364],
    [0.00000907379, 2.28356519128, 433.7117378768],
    [0.00000605936, 3.17456913264, 227.5261894396],
    [0.00000596411, 4.13395467306, 14.2270940016],
    [0.00000483108, 1.17313249713, 639.897286314],
    [0.00000393213],
    [0.00000229396, 4.69783424016, 419.4846438752],
    [0.00000187917, 4.5908926492, 110.2063212194],
];

const VSOP87_R4: Vsop87Element = [
    [0.00001202117, 1.41498340225, 220.4126424388],
    [0.00000707794, 1.16151449537, 213.299095438],
    [0.00000516224, 6.2404910535, 206.1855484372],
    [0.00000426107, 2.46891791825, 7.1135470008],
];

const VSOP87_R5: Vsop87Element = [[0.00000128668, 5.91279864289, 220.4126424388]];

export const VSOP87_X: Vsop87Group = [VSOP87_L0, VSOP87_L1, VSOP87_L2, VSOP87_L3, VSOP87_L4, VSOP87_L5];
export const VSOP87_Y: Vsop87Group = [VSOP87_B0, VSOP87_B1, VSOP87_B2, VSOP87_B3, VSOP87_B4, VSOP87_B5];
export const VSOP87_Z: Vsop87Group = [VSOP87_R0, VSOP87_R1, VSOP87_R2, VSOP87_R3, VSOP87_R4, VSOP87_R5];
